import styled from 'styled-components';

const SectionContainer = styled.div`
  background: white;

  .section-job-posts-hero--wrapper {
    padding-top: 182px;
    background: ${props => props.background};
  }

  .section-job-posts-hero--container {
    margin: 0 auto;
    padding: 40px 0;

    .section-job-posts-hero--title {
      font-size: 49px;
      font-weight: 900;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.04em;
      color: var(--black-color);
      max-width: 700px;
      margin: 0 auto;
      padding: 0 28px;
    }

    .section-job-posts-hero--description {
      font-size: 20px;
      font-weight: 500;
      line-height: 150%;
      color: var(--black-color);
      text-align: center;
      max-width: 840px;
      margin: 0 auto;
      margin-top: 24px;
      padding: 0 28px;
    }

    .section-job-posts-hero--card-content {
      margin: 0 auto;
      padding: 80px 28px 0;
      max-width: 1252px;

      .section-job-posts-hero--card-container {
        margin-bottom: 40px;
      }
    }
  }

  @media (max-width: 1450px) {
    .section-job-posts-hero--wrapper {
      padding-top: 160px;
    }
  }

  @media (max-width: 768px) {
    .section-job-posts-hero--container {
      .section-job-posts-hero--title {
        font-size: 29px;
        padding: 0 20px;
      }

      .section-job-posts-hero--description {
        font-size: 16px;
        margin-top: 20px;
        padding: 0 20px;
      }

      .section-job-posts-hero--card-content {
        padding: 35px 21px 20px;
      }
    }
  }

  @media (max-width: 576px) {
    .section-job-posts-hero--wrapper {
      padding-top: 148px;
    }

    .section-job-posts-hero--container {
      margin: 0 auto;
      padding-bottom: 0;

      .section-job-posts-hero--card-content {
        padding-top: 30px;

        .section-job-posts-hero--card-container {
          margin-bottom: 0;

          & > .ant-col {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
`;

export { SectionContainer };
